import { useDataEntryContext } from "../context/reducer.provider";
import { useTimerContext } from "../context/timer.provider";
import type { Strand } from "../models/caster.models";

const canOpenStrandLoss = (strand: Strand): boolean =>
  strand.StrandLossId !== null &&
  strand.StrandsParentAssetId !== null &&
  strand.StrandAssetId !== null;

export const useStrandLossJustify = () => {
  const { pause, resume } = useTimerContext();
  const {
    state: { selectedStrandLossId },
    actions: { setSelectedStrandLossId },
  } = useDataEntryContext();

  const openStrandLossById = (strandLossId: number) => {
    pause();
    setSelectedStrandLossId(strandLossId);
  };

  const openStrandLoss = (strand: Strand) => {
    if (!canOpenStrandLoss(strand)) return;

    openStrandLossById(strand.StrandLossId!);
  };

  const closeStrandLoss = () => {
    setSelectedStrandLossId(null);
    resume();
  };

  return {
    selectedStrandLossId,
    openStrandLoss,
    openStrandLossById,
    closeStrandLoss,
  };
};
